<template>
  <modal name="capacity-select" height="100%" scrollable style="z-index: 1050; display: flex; justify-content: center">
    <div class="modal-search-people">
      <CapacityFields v-bind="$props" @updateValue="(key, value) => $emit('updateValue', key, value)" />
    </div>
    <div class="modal-fixbottom">
      <button class="modal-primarybtn" @click.prevent="$modal.hide('capacity-select')">決定</button>
    </div>
  </modal>
</template>

<script>
import CapacityFields from './CapacityFields.vue'

export default {
  components: {
    CapacityFields,
  },
  // Same props as CapacityFields; declared here so v-bind="$props" forwards them.
  props: CapacityFields.props,
}
</script>
